export var srri = [{
  risk: 1,
  label: 'Muy defensivo',
  color: '',
  backgroundImage: 'https://www.finect.com/image/268b5718981a613624705eec2ca5a1c2b9efcf74182'
}, {
  risk: 2,
  label: 'Defensivo',
  color: '',
  backgroundImage: 'https://www.finect.com/image/31160dfd72ba9ce2df315b5bfad7f83d2b4766b5d3d'
}, {
  risk: 3,
  label: 'Conservador',
  color: '',
  backgroundImage: 'https://www.finect.com/image/38b3df307352b9a17fed5459f60da840032287625c4'
}, {
  risk: 4,
  label: 'Moderado',
  color: '',
  backgroundImage: 'https://www.finect.com/image/956740a6217a2c17e7fe5e346f985653ae08bc75e56'
}, {
  risk: 5,
  label: 'Arriesgado',
  color: '',
  backgroundImage: 'https://www.finect.com/image/339d5b38643622a69363e4bd8882a781e32dbbc51d9'
}, {
  risk: 6,
  label: 'Agresivo',
  color: '',
  backgroundImage: 'https://www.finect.com/image/04a42044cefbfe4e77c4402283b93ccfe44a6be23ee'
}, {
  risk: 7,
  label: 'Muy agresivo',
  color: '',
  backgroundImage: 'https://www.finect.com/image/1ae4b82cfc3e6e1ba1afa9d7fdbe96ed8a17e7ddd27'
}];